import React, { PropsWithChildren } from 'react';

type MaybeProps = PropsWithChildren<{
  shouldRender: boolean;
  FallbackComponent?: unknown;
}>;

const Maybe: React.FC<MaybeProps> = ({ shouldRender, FallbackComponent, ...props }) => {
  if (shouldRender) return <>{props.children}</>;

  return <>{FallbackComponent ?? null}</>;
};

export default Maybe;
